import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import {
  AUTH_CONFIG_MAP,
  AUTH_CONFIG_MAP_DEFAULT,
  AUTH_ENDPOINT,
  AUTH_ENDPOINT_INTEGRATION
} from '../helpers/constants';
import {environment} from "../../../environments/environment";

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: sessionStorage['siakE2E']
          ? AUTH_ENDPOINT_INTEGRATION
          : AUTH_ENDPOINT,
        postLoginRoute: 'main/precleaning',
        redirectUrl: `${window.location.origin}${window.location.pathname}`,
        postLogoutRedirectUri: `${window.location.origin}${window.location.pathname}`,
        clientId: AUTH_CONFIG_MAP[location.hostname] ?? AUTH_CONFIG_MAP_DEFAULT,
        scope: 'openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        maxIdTokenIatOffsetAllowedInSeconds: 600,
        autoUserInfo: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: environment.production ? LogLevel.None : LogLevel.Debug
      }
    })
  ],
  exports: [AuthModule]
})
export class AuthenticationConfigModule { }
